<template>
  <div>
    <b-navbar
      toggleable="lg"
      class="page-header py-lg-0"
    >
      <router-link
        to="/freight-orders"
        class="main-nav__link main-nav__link--logo"
      >
        <img
          :src="`${apiURL}/logo/icon-logo.svg`"
        >
      </router-link>
      <b-navbar-toggle
        class="ml-auto"
        target="nav-collapse"
      />
      <b-collapse
        id="nav-collapse"
        class="justify-content-between"
        is-nav
      >
        <b-navbar-nav>
          <ul class="main-nav__link-routers">
            <li
              v-for="it in navigation"
              :key="it.label"
            >
              <router-link
                v-if="it.hasRights"
                :key="it.label"
                :to="it.link"
                class="main-nav__link"
                @click.native="closeMenu"
              >
                {{ $t(it.label) }}
              </router-link>
            </li>
          </ul>
        </b-navbar-nav>

        <div class="main-nav__right-block">
          <div class="main-nav__dropdowns">
            <div class="dropdown">
              <button
                id="dropdownMenuButton"
                type="button"
                class="dropdown-toggle main-nav__dropdown d-flex"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {{ $t('Help') }}
              </button>

              <div
                class="dropdown-menu"
                aria-labelledby="dropdownMenuButton"
              >
                <a
                  class="dropdown-item cursor-pointer"
                  :href="`/${helpUserFileName}`"
                  target="_blank"
                >
                  <i class="ace-icon icon-info" />
                  <p>{{ $t('Information') }}</p>

                </a>
                <a
                  v-if="user.is_manager"
                  class="dropdown-item cursor-pointer"
                  :href="`/${helpManagerFileName}`"
                  target="_blank"
                >
                  <i
                    class="ace-icon icon-employeeinfo"
                    width="24"
                    height="24"
                  />
                  <p>{{ $t('Internal help') }}</p>
                </a>
                <a
                  class="dropdown-item cursor-pointer"
                  href="http://sd.transgr.ru/servicedesk/customer/portal/2/user/"
                  target="_blank"
                >
                  <i class="ace-icon icon-support" />
                  <p>{{ $t('Service desk') }}</p>
                </a>
                <a
                  class="dropdown-item cursor-pointer"
                  href="mailto:info@qborder.ru"
                >
                  <i class="ace-icon icon-mention" />
                  <p>info@qborder.ru</p>
                </a>
              </div>
            </div>

            <dx-select-box
              :items="languageTypes"
              styling-mode="outlined"
              field-template="field"
              item-template="item"
              class="choose-language"
              display-expr="item"
              :value="displayLanguageTypes"
            >
              <template #item="{ data }">
                <div
                  class="d-flex flex-row align-items-center"
                  @click.prevent="changeLocale(data.language)"
                >
                  <img
                    :src="require('/src/icons/'+ data.icon)"
                    class="mr-1"
                  >
                  <p class="mb-0">
                    {{ data.text }}
                  </p>
                </div>
              </template>
              <template #field="{ data }">
                <div class="d-flex flex-row align-items-center">
                  <img
                    v-if="data"
                    :src="require('/src/icons/'+ data.icon)"
                    class="mr-1"
                  >
                  <dx-text-box
                    :value=" data.icon && data.text"
                    :read-only="true"
                  />
                </div>
              </template>
            </dx-select-box>
          </div>

          <div class="main-nav__devider" />

          <div class="dropdown">
            <button
              id="dropdownMenuButton"
              type="button"
              class="main-nav__dropdown d-flex"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              left
            >
              <div class="main-nav__user">
                <div class="main-nav__user-container">
                  <p class="main-nav__user-name">
                    <span class="mr-1">
                      {{ user.first_name }}
                    </span>
                    <span>
                      {{ user.last_name }}
                    </span>
                  </p>
                  <p class="main-nav__user-job">
                    {{ user.username }}
                  </p>
                </div>
                <img
                  class="main-nav__user-photo"
                  src="@/icons/icon-user.svg"
                >
              </div>
            </button>

            <div
              class="dropdown-menu"
              aria-labelledby="dropdownMenuButton"
            >
              <router-link
                class="dropdown-item cursor-pointer"
                to="/profile"
              >
                <i class="ace-icon icon-user" />
                <p>{{ $t('Profile') }}</p>
              </router-link>
              <router-link
                v-if="user.can_edit_refbook"
                class="dropdown-item cursor-pointer"
                to="/transport"
              >
                <i class="ace-icon icon-transport" />
                <p>{{ $t('Transport') }}</p>
              </router-link>
              <router-link
                v-if="user.is_manager"
                class="dropdown-item cursor-pointer"
                to="/services"
              >
                <i class="ace-icon icon-services" />
                <p> {{ $t('Services') }} </p>
              </router-link>
              <a
                class="dropdown-item cursor-pointer"
                @click.prevent="resetLayout"
              >
                <i class="ace-icon icon-refresh" />
                <p>{{ $t('Reset layout') }}</p>
              </a>
              <a
                class="dropdown-item cursor-pointer"
                @click.prevent="logOut"
              >
                <i class="ace-icon icon-exit" />
                <p>{{ $t('Logout') }}</p>
              </a>
            </div>
          </div>
        </div>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ruMessages from 'devextreme/localization/messages/ru.json';

import { locale as localize, loadMessages } from 'devextreme/localization';
import DxSelectBox from 'devextreme-vue/select-box';

import DxTextBox from 'devextreme-vue/text-box';
import mixinDetictingMobile from '@/mixins/mixin-detecting-mobile';

export default {
  name: 'AppHeader',
  components: {
    DxSelectBox,
    DxTextBox,
  },
  mixins: [mixinDetictingMobile],
  data: () => ({
    version: process.env.VUE_APP_VERSION,
    isTestVersion: process.env.VUE_APP_TEST_VERSION === 'true',
    helpUserFileName: process.env.VUE_APP_HELP_FILENAME,
    helpManagerFileName: process.env.VUE_APP_HELP_MANAGER_FILENAME,
    apiURL: process.env.VUE_APP_API_URL,
    contacts: [],
    languageTypes: [
      {
        language: 'ru',
        text: 'Рус',
        icon: 'icon-russian.svg',
      },
      {
        language: 'en',
        text: 'Eng',
        icon: 'icon-english.svg',
      },
      {
        language: 'cn',
        text: 'Chi',
        icon: 'icon-chinese.svg',
      },
    ],
  }),
  computed: {
    ...mapState(['user']),
    displayLanguageTypes() {
      return this.languageTypes.filter(it => it.language === this.$i18n.locale)[0];
    },
    navigation() {
      return [
        {
          link: '/freight-orders',
          label: 'Shipping orders',
          hasRights: true,
        },
        {
          link: '/tracking/monitoring',
          label: 'Tracking',
          hasRights: true,
        },
        {
          link: '/profiles',
          label: 'Profiles',
          hasRights: this.user.is_manager,
        },
        {
          link: '/companies',
          label: 'Companies',
          hasRights: this.user.is_manager,
        },
      ];
    },
  },
  created() {
    loadMessages(ruMessages);
    localize(this.$i18n.locale);
  },
  methods: {
    changeLocale(lang) {
      localStorage.setItem('locale', lang);
      this.$http.defaults.headers['Accept-Language'] = lang;
      this.$store.commit('refreshTable');
      this.$i18n.locale = lang;
    },
    logOut() {
      this.$store.commit('logOut');
    },
    resetLayout() {
      /* eslint-disable */
        if (!confirm('Вы уверены, что хотите сбросить настройки таблиц?')) {
          return;
        }

        let keyRemoved = false;
        let current_user = this.user;
        Object.keys(localStorage)
          .forEach(key => {
            if (key.endsWith('grid-storage') && key.startsWith(`u${current_user.id}`)) {
              localStorage.removeItem(key);
              keyRemoved = true;
            }
          });

        if (keyRemoved) {
          this.$store.commit('refreshTable');
        }
      },
      closeMenu() {
        if (this.isMobile) {
          this.$root.$emit('bv::toggle::collapse', 'nav-collapse');
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .page-header {
    border-bottom: 2px solid #E0E6EE;
    @media(max-width: 1920px) {
      padding-left: 9rem;
      padding-right: 9rem;
    }
    @media(max-width: 1400px) {
      padding-left: 7rem;
      padding-right: 7rem;
    }
    @media(max-width: 1250px) {
      padding-left: 4rem;
      padding-right: 4rem;
    }
    @media(max-width: 992px) {
      padding: 1rem;
    }
  }

  .main-nav__link-routers {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    padding-left: 0;
    @media(max-width: 992px) {
      flex-direction: column;
      row-gap: 0.5rem;
      margin-bottom: 0.5rem;
    }
    li {
      position: relative;
      list-style: none;
      @media(max-width: 1920px) {
        margin-right: 2.5rem;
        padding-top: 40px;
        padding-bottom: 40px;
      }
      @media(max-width: 1720px) {
        margin-right: 2rem;
        padding-top: 30px;
        padding-bottom: 30px;
      }
      @media(max-width: 1600px) {
          margin-right: 1.5rem;
          padding-top: 30px;
          padding-bottom: 30px;
      }
      @media(max-width: 1330px) {
          margin-right: 1rem;
      }
      @media(max-width: 992px) {
        margin-right: 1rem;
        padding: 0;
      }
    }
  }



  .main-nav__link,
  .main-nav__dropdown,
  .main-nav__user-name,
  .dropdown-menu,
  .dropdown-item p,
  ::v-deep .dx-selectbox input.dx-texteditor-input,
  .dx-dropdowneditor-overlay .dx-list-item-content p {
    @media(max-width: 1920px) {
      font-size: 16px;
    }
    @media(max-width: 1720px) {
      font-size: 15px;
    }
    @media(max-width: 1600px) {
      font-size: 14px;
    }
    @media(max-width: 1330px) {
      font-size: 12px;
    }
    @media(max-width: 1100px) {
      font-size: 10px;
    }
  }

  .main-nav__link:not(.main-nav__link--logo) {
    position: relative;
  }

  .main-nav__link:not(.main-nav__link--logo)::after {
    position: absolute;
    content: "";
    background-color: transparent;
    display: block;
    width: 30px;
    left: calc(50% - 15px);
    height: 2px;
    @media(max-width: 1920px) {
      margin-top: 40px;
    }
    @media(max-width: 1720px) {
      width: 20px;
      left: calc(50% - 10px);
      margin-top: 30px;
    }
    @media(max-width: 992px) {
      display: none;
    }
  }

  .main-nav__link.router-link-active:not(.main-nav__link--logo)::after {
      content: "";
      background-color: #3C5AC3;
      transition: background-color .6s cubic-bezier(.4, 0, .02, 1);;
    }

  .main-nav__link--logo {
    @media(max-width: 1920px) {
      margin-right: 5rem;
    }
    @media(max-width: 1720px) {
      margin-right: 2.5rem;
    }
    @media(max-width: 1600px) {
      margin-right: 2rem;
    }
    @media(max-width: 1330px) {
      margin-right: 1.2rem;
    }
    @media(max-width: 992px) {
      margin-right: 1rem;
    }
  }

  .main-nav__devider {
    width: 2px;
    background-color:#E0E6EE;
    border-radius: 8px;
    @media(max-width: 1920px) {
      height: 65px;
      margin-left: 1.25rem;
      margin-right: 1.25rem;
    }
    @media(max-width: 1720px) {
      height: 60px;
      margin-left: 1rem;
      margin-right: 1rem;
    }
    @media(max-width: 1600px) {
      height: 55px;
      margin-left: 0.75rem;
      margin-right: 0.75rem;
    }
    @media(max-width: 1330px) {
      height: 50px;
      margin-left: 0.5rem;
      margin-right: 0.5rem;
    }
    @media(max-width: 992px) {
      display: none;
    }
  }

  .main-nav__user {
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    column-gap: 0.75rem;
    align-items: center;
    padding-left: 5px;
    padding-right: 5px;
    @media(max-width: 992px) {
      flex-direction: column;
      padding: 0;
    }
  }

  .main-nav__user-name {
    display: flex;
    @media(max-width: 1450px) {
      flex-direction: column;
    }
    @media(max-width: 992px) {
      flex-direction: row;
    }
  }
  .main-nav__user-job {
    font-size: 12px;
    font-weight: 400;
    @media(max-width: 1100px) {
      font-size: 10px;
    }
  }

  .main-nav__user-name,
  .main-nav__user-job {
    margin-bottom: 0;
    text-align: right;
    @media(max-width: 1450px) {
      text-align: left;
    }
  }

  .main-nav__user-photo {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    @media(max-width: 992px) {
      display: none;
    }
  }

  .dropdown button{
    @media(max-width: 992px) {
      padding: 0;
      margin: 0;
      border: none;
    }
  }
  .dropdown-menu {
    padding-top: 4px;
    padding-bottom: 4px;
    border-radius: 8px;
    border-color: #E0E6EE;
  }

  .dropdown-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 42px;
    margin-bottom: 0;
    padding-left: 0.5rem;
    border-radius: 5px;
    background-color: #fff;
    font-weight: 600;
    &:hover,
    &:focus {
      background-color: #f4f8fa;
    }
    p {
      margin-bottom: 0;
      color: black;
    }
    i,
    img {
      margin-right: 0.5rem;
    }
  }
  .main-nav__dropdown {
    align-items: center;
    box-sizing: border-box;
    padding: 2px 0 2px 2px;
    border: 2px solid transparent;
    border-radius: 8px;
    color: black;
    background-color: transparent;
    font-weight: 600;
    &:focus {
      transition: .6s cubic-bezier(.4, 0, .02, 1);
      border: 2px solid #3C5AC3;
      @media(max-width: 992px) {
        border: none;
      }
    }
  }

  .dropdown-toggle::after {
    content: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16 10.1429L12 14L8 10.1429' stroke='%233C5AC3' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
    height: 24px;
    width: 24px;
    margin: 0;
    vertical-align: middle;
    border: none;
  }

  .main-nav__right-block,
  .main-nav__dropdowns {
    display: flex;
    flex-direction: row;
    align-items: center;
    @media(max-width: 992px) {
      flex-direction: column;
      align-items: flex-start;
      row-gap: 0.5rem;
    }
  }

  .choose-language {
    padding-left: 0.2rem;
    color: black;
    box-shadow: inset 0 0 0 2px transparent !important;
    margin-bottom: 0;
    @media(max-width: 1920px) {
      width: 6.5rem;
    }
    @media(max-width: 1600px) {
      width: 6rem;
    }
    @media(max-width: 992px) {
      width: 5.1rem;
      padding-left: 0;
    }
    &.dx-dropdowneditor-active {
      box-shadow: inset 0 0 0 2px #3C5AC3 !important;
      @media(max-width: 992px) {
        box-shadow: 0 0 0 2px transparent !important;
      }
    }
  }

::v-deep input.dx-texteditor-input {
      color: black !important;
      width: 30px !important;
      padding: 8px 0 !important;
    }

</style>

